{
    "ReportingMenu_FirstClosePopup": "Om het menu opnieuw te openen, klikt u op de knop 'Rapportage' in de zijbalk terwijl u zich op de pagina Rapportage bevindt.",
    "NAME": "ReportingMenuLanguage"
}